import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { UserActions } from '../../../store/actions/users';
import { DebounceCreators } from '../../../store/actions/debounce';

import InputDropdown from '../../../bergmannsoft/components/Widgets/Forms/InputDropdown';

const OrganizationsSelect = ({ user, organizations }) => {
  const claimIsRoot = useSelector((state) => state.users.signedUserIsRoot);

  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const allOrganizations = organizations;
  const [orgsCompany, setOrgsCompany] = useState([]);

  const debounce = useSelector((state) => state.debounce);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (
      (user &&
        user.organizations &&
        user.organizations.length > 0 &&
        orgsCompany.length === 0) ||
      (user && claimIsRoot && orgsCompany.length === 0)
    ) {
      const orgs = claimIsRoot ? allOrganizations : user.organizations;
      const selectedOrg = orgs.find(
        (org) => org._id === user.selectedOrganization
      );
      setSelectedOrganization(selectedOrg);

      let orgsResult = [];
      if (user.selectedCompany) {
        orgsResult = orgs.filter((i) => {
          return i.companyId === user.selectedCompany._id;
        });
      }

      setOrgsCompany(orgsResult);
    }
  }, [user]);

  function goToBots() {
    history.push('/bots');
  }

  function handleSelectOrganization(optionSelected) {
    const { selectOrganization } = UserActions;
    if (debounce.list.length > 0) {
      if (window.confirm('Seu bot não foi salvo, deseja continuar?')) {
        dispatch(DebounceCreators.clearDebounce());

        dispatch(selectOrganization(optionSelected._id));
        goToBots();
      }
    } else {
      dispatch(selectOrganization(optionSelected._id));
      goToBots();
    }
  }

  return (
    <InputDropdown
      className="dropdown-header-organizations"
      value={selectedOrganization?.name || ''}
      dropdownItemsList={orgsCompany}
      onChange={(value) => handleSelectOrganization(value)}
      styleWidth="100%"
      darkMode
    />
  );
};

export default OrganizationsSelect;
